var _rect, _rect2, _text, _text2, _text3, _text4, _text5, _line, _rect3, _rect4, _rect5, _rect6, _text6, _text7, _rect7, _rect8, _text8, _rect9, _line2, _line3, _line4, _text9, _text10, _text11, _line5, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _rect10, _line6, _line7, _rect11, _line8, _line9, _rect12, _line10, _line11, _rect13, _line12, _line13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHxm96Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#777777",
    height: 382,
    id: "svg_5",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 382,
    x: 8.5,
    y: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f9fafb",
    height: 183.999992,
    id: "svg_6",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 261.499982,
    x: 68.000006,
    y: 92.499994
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_7",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 66.5,
    xmlSpace: "preserve",
    y: 55
  }, "Hakaru+")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_8",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 335,
    xmlSpace: "preserve",
    y: 55
  }, "HXM-96")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 27,
    fontWeight: "bold",
    id: "svg_18",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 225.44531,
    xmlSpace: "preserve",
    y: 152
  }, "4021")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_16",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 275.5,
    xmlSpace: "preserve",
    y: 152
  }, "A")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_25",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 0,
    textAnchor: "middle",
    x: 97,
    xmlSpace: "preserve",
    y: 116
  }, "IIns")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_29",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 77,
    x2: 325.024965,
    y1: 120.5,
    y2: 120.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 20.000001,
    id: "svg_19",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 60.000002,
    x: 77.499999,
    y: 254.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 20.000001,
    id: "svg_22",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 60.000002,
    x: 138.499999,
    y: 254.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 20.000001,
    id: "svg_23",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 60.000002,
    x: 199.499999,
    y: 254.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 20.000001,
    id: "svg_24",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    width: 60.000002,
    x: 260.999999,
    y: 254.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_11",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 106,
    xmlSpace: "preserve",
    y: 269
  }, "Menu")), /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_26",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 168,
    xmlSpace: "preserve",
    y: 269.5
  }, "Prev"), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_27",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 229.5,
    xmlSpace: "preserve",
    y: 269.5
  }, "Next")), /*#__PURE__*/React.createElement("text", {
    fill: "#f9fafb",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_28",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 291.5,
    xmlSpace: "preserve",
    y: 269.5
  }, "Max"), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    fillOpacity: 0,
    height: 20.000001,
    id: "svg_30",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 60.000002,
    x: 77.499999,
    y: 100
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    fillOpacity: 0,
    height: 20.000001,
    id: "svg_31",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 85.000002,
    x: 239.499998,
    y: 100.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "normal",
    id: "svg_32",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 282,
    xmlSpace: "preserve",
    y: 115.5
  }, "AL1 AL2 AL3")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    fillOpacity: 0,
    height: 20.000001,
    id: "svg_33",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 27.500002,
    x: 267.999999,
    y: 100.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_34",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 77,
    x2: 324.524965,
    y1: 155,
    y2: 155
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_35",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 77,
    x2: 325.024965,
    y1: 187.5,
    y2: 187.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_36",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 77,
    x2: 325.024965,
    y1: 220.5,
    y2: 220.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 27,
    fontWeight: "bold",
    id: "svg_37",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 224.44531,
    xmlSpace: "preserve",
    y: 184.5
  }, "4022")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 27,
    fontWeight: "bold",
    id: "svg_38",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 225.44531,
    xmlSpace: "preserve",
    y: 217.5
  }, "4021")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 27,
    fontWeight: "bold",
    id: "svg_39",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 253.44531,
    xmlSpace: "preserve",
    y: 249
  }, "0")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_40",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 77,
    x2: 326.024965,
    y1: 252,
    y2: 252
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_41",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 276.5,
    xmlSpace: "preserve",
    y: 183.5
  }, "A")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_42",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 276.5,
    xmlSpace: "preserve",
    y: 216.5
  }, "A")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_43",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 276,
    xmlSpace: "preserve",
    y: 247.5
  }, "A")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_44",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 85,
    xmlSpace: "preserve",
    y: 150.5
  }, "I1")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_45",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 85,
    xmlSpace: "preserve",
    y: 183.5
  }, "I2")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_46",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 85,
    xmlSpace: "preserve",
    y: 215.5
  }, "I3")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 15,
    fontWeight: "normal",
    id: "svg_47",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 86,
    xmlSpace: "preserve",
    y: 247
  }, "IN")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#191919",
    height: 52,
    id: "svg_4",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 95.5,
    y: 310.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_48",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 106.75,
    x2: 106.75,
    y1: 293,
    y2: 305.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_49",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 107.25,
    x2: 107.25,
    y1: 322.5,
    y2: 349.249999
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#191919",
    height: 52,
    id: "svg_52",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 157.5,
    y: 310.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_53",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 168.75,
    x2: 168.75,
    y1: 293,
    y2: 305.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_54",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 169.25,
    x2: 169.25,
    y1: 322.5,
    y2: 349.249999
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#191919",
    height: 52,
    id: "svg_56",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 217.5,
    y: 310.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_57",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 228.75,
    x2: 228.75,
    y1: 293,
    y2: 305.75
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_58",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 229.25,
    x2: 229.25,
    y1: 322.5,
    y2: 349.249999
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#191919",
    height: 52,
    id: "svg_60",
    stroke: "#333333",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 278,
    y: 310.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_61",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 289.25,
    x2: 289.25,
    y1: 293,
    y2: 305.75
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_62",
    stroke: "#bf5f00",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    x1: 289.75,
    x2: 289.75,
    y1: 322.5,
    y2: 349.249999
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxm96Dark);
export default __webpack_public_path__ + "static/media/hxm96_dark.657e8c55.svg";
export { ForwardRef as ReactComponent };